import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { O365AuthService, ROLES } from '../../../services/o365-auth.service';

export interface MenuItem {
  id: string;
  icon: string | null;
  label: string | null;
  route?: string | null; // Optional: For routing
  roles?: string[]; // User roles allowed to view
  children?: MenuItem[]; // Optional: For nested menus
  separator?: boolean; // Optional: For visual separators
}

const menuItems: MenuItem[] = [
  { id: 'home', icon: 'home', label: 'Home', route: '/home' },
  { id: 'person', icon: 'person', label: 'Contacts', route: '/contacts' },
  { id: 'groups', icon: 'groups', label: 'Organisations', route: '/organisations' },
  { id: 'projects', icon: 'view_timeline', label: 'Projects', route: '/projects' },
  { id: 'events', icon: 'event', label: 'Events', route: '/events' },
  // { id: 'members', icon: 'inventory', label: 'Members', route: '/members' },``
  { id: 'divider1', icon: null, label: null, route: null },
  { id: 'suppliers', icon: 'inventory', label: 'Suppliers', route: '/suppliers' },
  { id: 'divider2', icon: null, label: null, route: null },
  { id: 'upload', icon: 'upload_file', label: 'Upload data', route: '/upload' },
  { id: 'import', icon: 'data_check', label: 'Import data', route: '/import' },
  { id: 'divider3', icon: null, label: null, route: null },

  { id: 'settings', icon: 'settings', label: 'Settings', roles: [ROLES.ADMIN],route: '/settings' },
  // {
  //   id: 'admin', icon: 'settings', label: 'Admin', route: '/admin', roles: [ROLES.ADMIN], children:
  //     [
  //       { id: 'upload', icon: 'upload_file', label: 'Upload data', route: '/admin/upload' },
  //       { id: 'import', icon: 'data_check', label: 'Import data', route: '/admin/import' },
  //       { id: 'settings', icon: 'settings', label: 'Settings', route: '/admin/settings' },
  //     ]
  // },
  // { id: 'about', icon: 'info', label: 'About', route: '/about' },
];


@Component({
  selector: 'app-menu',
  imports: [
    MatTreeModule,
    RouterModule,
    MatIconModule,
    MatListModule,
    MatCheckboxModule
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {
  ROLES = ROLES;

  childrenAccessor = (node: MenuItem) => node.children ?? [];
  hasChild = (_: number, node: MenuItem) => !!node.children && node.children.length > 0;
  dataSource = menuItems;
  expandedItems = signal<string[]>([]);
  readonly filteredMenuItems = computed(() =>
    menuItems
      .filter(item => this.authService.hasAnyRole(item.roles))
      .map(item => ({
        ...item,
        children: item.children?.filter(child =>
          this.authService.hasAnyRole(child.roles)
        )
      }))
  );

  constructor(public authService: O365AuthService) { }

  toggle(itemId: string) {
    if (this.expandedItems().includes(itemId)) {
      this.expandedItems.update(items => items.filter(i => i !== itemId))
    } else {
      this.expandedItems.update(items => [...items, itemId])
    }
  }

  get menuItems() {
    return menuItems;
  }

  updateViewAsRegular(checked: boolean) {
    this.authService.viewAsRegular.set(checked);
  }
}
